module.exports = __webpack_public_path__ + "img/banner@2x.7a823811.png";